var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Campaign",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.819,
    height: 20,
    viewBox: "0 0 18.819 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M17.441,20.31H3.968A2.678,2.678,0,0,1,1.29,17.632V4.159A2.669,2.669,0,0,1,3.968,1.49H6.106V.31H7.6V1.49h6.2V.31h1.5V1.49h2.139a2.669,2.669,0,0,1,2.669,2.669V17.632a2.686,2.686,0,0,1-2.669,2.678ZM3.968,2.988A1.172,1.172,0,0,0,2.8,4.151V17.632a1.18,1.18,0,0,0,1.18,1.18H17.441a1.2,1.2,0,0,0,1.18-1.18V4.159a1.189,1.189,0,0,0-1.18-1.172Zm13.4,5.774H4.156V4.373H17.372Z",
    transform: "translate(-1.29 -0.31)",
    fill: "current"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2405",
    "data-name": "Rectangle 2405",
    width: 7,
    height: 7,
    transform: "translate(6 10)",
    fill: "current"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/Campaign.2c5f96c94f85eea6916a4475796eef12.svg";
export { ForwardRef as ReactComponent };